import * as React from "react";
import { translate } from "../locales/src/translate";

export interface DownloadButtonProps {
  disabled?: boolean;
  base64String: string;
  name: string;
}

export const DownloadButton = (props: DownloadButtonProps) => {
    const handleDownload = () => {
        const byteCharacters = atob(props.base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const anchorElement = document.createElement('a');
        anchorElement.href = URL.createObjectURL(blob);
        anchorElement.download = props.name;
        anchorElement.click();
    };
    
  return (
    <button
      type="button"
      className={`btn btn--primary btn--download download-block__button ${props.disabled ? "disabled" : ""}`}
      id="downloadPdfButton"
      disabled={props.disabled}
      data-testid="downloadPdfButton"
      onClick={(event) => {
        event.preventDefault();
        handleDownload();
        return false;
      }}
    >
      {translate("Klantondersteuning_Formulieren_OpslaanAlsPdf")}
      <span className="icon icon-download"></span>
    </button>
  );
};
